import { render } from "./Money.vue?vue&type=template&id=9540c71a"
import script from "./Money.vue?vue&type=script&setup=true&lang=js"
export * from "./Money.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Form/Money.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9540c71a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9540c71a', __exports__)) {
    api.reload('9540c71a', __exports__)
  }
  
  module.hot.accept("./Money.vue?vue&type=template&id=9540c71a", () => {
    api.rerender('9540c71a', render)
  })

}


export default __exports__